"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceTimingEnum = exports.FrequencyEnum = exports.DurationUnitTypesEnum = exports.SlotTypeEnum = exports.ReservationMigrationStatusEnum = exports.ReservationStatusEnum = exports.ReservationPaymentStatusOptions = exports.ReservationExtendedEnum = exports.DurationTypeEnum = exports.ReservationTypeEnum = exports.PrivacySettingsEnum = exports.ItemResourceEnum = void 0;
const payment_enums_1 = require("../../../payment/types/enums/payment.enums");
var ItemResourceEnum;
(function (ItemResourceEnum) {
    ItemResourceEnum["SEGMENTS"] = "segments";
    ItemResourceEnum["SERIES"] = "series";
    ItemResourceEnum["SLOTS"] = "slots";
    ItemResourceEnum["RESERVATION_ADDONS"] = "reservation_addons";
    ItemResourceEnum["SLOT_ADDONS"] = "slot_addons";
})(ItemResourceEnum = exports.ItemResourceEnum || (exports.ItemResourceEnum = {}));
var PrivacySettingsEnum;
(function (PrivacySettingsEnum) {
    PrivacySettingsEnum["PUBLIC"] = "public";
    PrivacySettingsEnum["PRIVATE"] = "private";
    PrivacySettingsEnum["HIDDEN"] = "hidden";
})(PrivacySettingsEnum = exports.PrivacySettingsEnum || (exports.PrivacySettingsEnum = {}));
var ReservationTypeEnum;
(function (ReservationTypeEnum) {
    ReservationTypeEnum["RENTAL"] = "rental";
    ReservationTypeEnum["PROGRAM"] = "program";
    ReservationTypeEnum["MAINTENANCE"] = "maintenance";
    ReservationTypeEnum["CUSTOM"] = "custom";
    ReservationTypeEnum["INTERNAL"] = "internal";
})(ReservationTypeEnum = exports.ReservationTypeEnum || (exports.ReservationTypeEnum = {}));
var DurationTypeEnum;
(function (DurationTypeEnum) {
    DurationTypeEnum["DATES"] = "dates";
    DurationTypeEnum["ALL_DAY"] = "all day";
    DurationTypeEnum["DURATION"] = "duration";
})(DurationTypeEnum = exports.DurationTypeEnum || (exports.DurationTypeEnum = {}));
var ReservationExtendedEnum;
(function (ReservationExtendedEnum) {
    ReservationExtendedEnum["PURCHASE_ORDER"] = "purchase_order";
})(ReservationExtendedEnum = exports.ReservationExtendedEnum || (exports.ReservationExtendedEnum = {}));
exports.ReservationPaymentStatusOptions = [
    ...Object.values(payment_enums_1.PaymentStatusEnum),
    ...Object.values(ReservationExtendedEnum),
];
var ReservationStatusEnum;
(function (ReservationStatusEnum) {
    ReservationStatusEnum["PLANNED"] = "Planned";
    ReservationStatusEnum["APPROVED"] = "Approved";
    ReservationStatusEnum["AWAITING_ADMIN"] = "Awaiting Admin";
    ReservationStatusEnum["AWAITING_CUSTOMER"] = "Awaiting Customer";
    ReservationStatusEnum["REJECTED"] = "Rejected";
    ReservationStatusEnum["CANCELED"] = "Canceled";
})(ReservationStatusEnum = exports.ReservationStatusEnum || (exports.ReservationStatusEnum = {}));
var ReservationMigrationStatusEnum;
(function (ReservationMigrationStatusEnum) {
    ReservationMigrationStatusEnum["NEW"] = "new";
    ReservationMigrationStatusEnum["NO"] = "no";
    ReservationMigrationStatusEnum["YES"] = "yes";
})(ReservationMigrationStatusEnum = exports.ReservationMigrationStatusEnum || (exports.ReservationMigrationStatusEnum = {}));
var SlotTypeEnum;
(function (SlotTypeEnum) {
    SlotTypeEnum["EXTERNAL"] = "external";
    SlotTypeEnum["INTERNAL"] = "internal";
    SlotTypeEnum["MAINTENANCE"] = "maintenance";
    SlotTypeEnum["CUSTOM"] = "custom";
})(SlotTypeEnum = exports.SlotTypeEnum || (exports.SlotTypeEnum = {}));
var DurationUnitTypesEnum;
(function (DurationUnitTypesEnum) {
    DurationUnitTypesEnum["MINUTES"] = "minutes";
    DurationUnitTypesEnum["HOURS"] = "hours";
    DurationUnitTypesEnum["DAYS"] = "days";
})(DurationUnitTypesEnum = exports.DurationUnitTypesEnum || (exports.DurationUnitTypesEnum = {}));
var FrequencyEnum;
(function (FrequencyEnum) {
    FrequencyEnum["NONE"] = "none";
    FrequencyEnum["WEEKLY"] = "weekly";
    FrequencyEnum["DAILY"] = "daily";
    FrequencyEnum["MONTHLY"] = "monthly";
    FrequencyEnum["YEARLY"] = "yearly";
})(FrequencyEnum = exports.FrequencyEnum || (exports.FrequencyEnum = {}));
var MaintenanceTimingEnum;
(function (MaintenanceTimingEnum) {
    MaintenanceTimingEnum[MaintenanceTimingEnum["BEFORE"] = 1] = "BEFORE";
    MaintenanceTimingEnum[MaintenanceTimingEnum["AFTER"] = 2] = "AFTER";
    MaintenanceTimingEnum[MaintenanceTimingEnum["AT_THE_BEGINING"] = 3] = "AT_THE_BEGINING";
    MaintenanceTimingEnum[MaintenanceTimingEnum["AT_THE_END"] = 4] = "AT_THE_END";
})(MaintenanceTimingEnum = exports.MaintenanceTimingEnum || (exports.MaintenanceTimingEnum = {}));
//# sourceMappingURL=reservation.enums.js.map